import { render, staticRenderFns } from "./SmartMetricItem.vue?vue&type=template&id=6b579033&scoped=true&"
import script from "./SmartMetricItem.vue?vue&type=script&lang=js&"
export * from "./SmartMetricItem.vue?vue&type=script&lang=js&"
import style0 from "./SmartMetricItem.vue?vue&type=style&index=0&id=6b579033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b579033",
  null
  
)

export default component.exports